import { EventData, OnSiteConfig, WebPushConfig } from '../models/intrack-window.model';
import { Inject, Injectable } from '@angular/core';
import { NgxHybridService } from '@digipay/ngx-hybrid-service';
import { IntrackConfigModel } from '../models/intrack-config.model';

declare const window: any;

@Injectable({
  providedIn: 'root',
})
export class IntrackService {
  platform = '';
  webPushConfig: WebPushConfig = {
    subscriptionStyle: {
      subscriptionTheme: 0,
    },
  };
  onSiteConfig!: OnSiteConfig;

  constructor(
    private ngxHybridService: NgxHybridService,
    @Inject('APP_ENV') private environment: any,
  ) {
    this.setPlatform();
  }

  public intrackLoginEvent(userId: string) {
    try {
      if (!this.isIntrackExist()) {
        return;
      }
      const userDetail = {
        userId,
      };
      window.Intk('login', userDetail);
    } catch (e) {
      console.error('INTRACK_ERROR', e);
    }
  }

  public intrackLogoutEvent() {
    try {
      if (!this.isIntrackExist()) {
        return;
      }
      window.Intk('logout');
    } catch (e) {
      console.error('INTRACK_ERROR', e);
    }
  }

  public intrackOnSiteMessage() {
    try {
      if (!this.isIntrackExist()) {
        return;
      }
      window.Intk('initOnSiteMessaging', this.onSiteConfig);
    } catch (e) {
      console.error('INTRACK_ERROR', e);
    }
  }

  public intrackWebPush() {
    try {
      if (!this.isIntrackExist()) {
        return;
      }
      window.Intk('InitWebPush', this.webPushConfig);
    } catch (e) {
      console.error('INTRACK_ERROR', e);
    }
  }

  public initIntrack() {
    const intrackConfig: IntrackConfigModel = {
      app_key: this.environment.intrack_config.app_key,
      auth_key: this.environment.intrack_config.auth_key,
      public_key: this.environment.intrack_config.public_key,
      sw_path: '/ngsw-worker.js',
    };
    if (this.ngxHybridService.isHybrid()) {
      intrackConfig.webView = true;
      if (this.ngxHybridService.isAndroidHybrid()) {
        intrackConfig.android_auth_key = this.environment.intrack_config.android_auth_key;
      }
      if (this.ngxHybridService.isIosHybrid()) {
        intrackConfig.ios_auth_key = this.environment.intrack_config.ios_auth_key;
      }
    }
    (function addConfig(appWindow: any, document: Document, tagName: string, jsUrl: string, intkName: string, config, referenceNode) {
      const onload = (appWindow['InTrack'] = appWindow['InTrack'] || {});
      appWindow[intkName] =
        appWindow[intkName] ||
        function addItem() {
          (onload.q = onload.q || []).push(arguments);
        };
      const script: any = document.createElement(tagName);
      script.async = true;
      script.src = jsUrl;
      script.onload = function addOnload() {
        onload.init(config);
      };
      const element = document.getElementsByTagName(tagName)[0];
      element.parentNode?.insertBefore(script, referenceNode!);
    })(window, document, 'script', '//static1.intrack.ir/api/web/download/sdk/v1/inTrack.min.js?v=00', 'Intk', intrackConfig);
  }

  private setPlatform() {
    this.platform = this.ngxHybridService.isAndroidHybrid() ? 'Hybrid Android' : this.ngxHybridService.isIosHybrid() ? 'Hybrid IOS' : 'PWA';
  }

  private isIntrackExist(): boolean {
    return !!(window.Intk && typeof window.Intk === 'function');
  }

  // This method is used for send your custom event to intrack, just set your event name and event data.
  customIntrackEvent(eventData: EventData) {
    try {
      if (!this.isIntrackExist()) {
        return;
      }
      // Attention: platform is based on our needs in PWA project. You can delete this field if you want use in different project.
      window.Intk('sendEvent', {
        eventName: eventData.eventName,
        eventData: Object.assign(eventData.eventData!, { platform: this.platform }),
      });
    } catch (e) {
      console.error('INTRACK_ERROR', e);
    }
  }
}
